import _merge from 'lodash/merge';
import { t } from '../../i18n';
import { CallToAction } from '../../tornado/callToAction/primary/callToAction.component';
import { Controls } from '../../player/interface/controls/controls.component';
import { SEEK_SIGNAL } from '../../player/interface/controls/controls.constants';
import { getInitialStyle } from './controls.style';
import { sendEvent } from '../../../logic/analytics/analytics.utils';
import { CHAPTERS, EVENTS } from './controls.constants';

export class VideoControls extends Controls {
  static _template() {
    const base = super._template();

    return _merge(
      {
        ...base,
        AuxiliaryButtons: {
          ...base.AuxiliaryButtons,
          SkipChapterButton: {
            type: CallToAction,
          },
        },
      },
      getInitialStyle(),
    );
  }

  _detach() {
    super._detach();
    this._chapter = null;
  }

  set chapter(value) {
    this._chapter = value;

    if (!this._chapter) {
      this._setSkipButtonVisibilityState(false);

      return;
    }

    switch (this._chapter.type) {
      case CHAPTERS.INTRO: {
        this._setSkipButtonVisibilityState(true, t('player.skipIntro'));

        break;
      }
      case CHAPTERS.OPENING_CREDITS: {
        this._setSkipButtonVisibilityState(true, t('player.skipRecap'));

        break;
      }
      case CHAPTERS.ENDING_CREDITS: {
        this._setSkipButtonVisibilityState(true, t('player.skipCredits'));

        break;
      }
      default:
        this._setSkipButtonVisibilityState(false);

        break;
    }
  }

  _setSkipButtonVisibilityState(showButton, label = '') {
    const button = this.tag('SkipChapterButton');
    button.label = label || '';
    button.visible = showButton;

    if (this._autoHideDisablingViews.includes(this._focused)) {
      this._visibleFocusableItems = this._focusableItems.filter(item => item.visible);

      return;
    }

    if (showButton && this.isHidden) {
      this._visibleFocusableItems = this._focusableItems.filter(item => item.visible);
      this._setIndex(this._visibleFocusableItems.indexOf(button), false);
    } else {
      this._checkFocusableItems(false);

      // The _checkFocusableItems moves focus to the first focusable item (i.e. TopBar) while the Player requirements says we need to focus on the ProgressBar
      if (!showButton) {
        this._focusTag('Progress');
      }
    }

    this._refocus();
  }

  _handleEnter() {
    if (!this._chapter || this._focused !== this.tag('SkipChapterButton')) {
      return false;
    }

    const event = EVENTS[this._chapter.type];
    if (event) {
      sendEvent({ key: event });
      this.signal(SEEK_SIGNAL, this._chapter.tcEnd);
      this._setSkipButtonVisibilityState(false);

      return true;
    }

    return false;
  }
}
